import React from 'react'
import { Button, Divider, Dropdown, Menu, Space, Tag } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useTranslation } from '@nic/commons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faA, faD, faGlobe, faUser } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from '@nic/kc-auth'
import { DARWIN_ROLES, REGISTRY_USER_ROLES } from './const'
import {
  getTokenParsed,
  getUserDarwinRole,
  getUserNameFromToken,
  userDarwinRegistrarRoles,
  userDarwinRoles,
  userRealmRegistryOperatorRoles,
} from './utils'

interface IUserInfo {
  color?: string
}

export const UserInfo: React.FC<IUserInfo> = (props) => {
  const clr = props.color ?? 'white'
  const t = useTranslation()
  const { keycloak } = useAuth()
  const username = getUserNameFromToken(keycloak)
  const userInfo = getTokenParsed(keycloak)
  const menuHandler = (value: any) => {
    console.debug('Value ', value)
    switch (value.key) {
      case 'logout':
        console.log('logging out....')
        keycloak?.logout()
        break
      default:
        break
    }
  }

  /** This function returns a list of tags with the roles of the user in the registry realm */
  const darwin_registry_role_list = () => {
    let userList: any = []
    keycloak &&
    keycloak.realm === 'registry' &&
    DARWIN_ROLES.forEach(
      (r) => userDarwinRoles(keycloak)?.includes(r) && userList.push(<Tag>{r}</Tag>),
    )

    if (userList.length > 0) {
      return userList
    } else {
      return <Tag>{t('basic')}</Tag>
    }
  }

  const menu = (
    <Menu onClick={menuHandler} style={{ maxWidth: 200 }}>
      {keycloak && keycloak.realm === 'registrar' && (
        <Menu.ItemGroup title={'Registrar'}>
          <Menu.Item key={'hide-role'} disabled>
            {userInfo?.registrar}
          </Menu.Item>
        </Menu.ItemGroup>
      )}
      <Menu.ItemGroup title={t('darwinUserRoles')}>
        <Menu.Item key={'hide-role'} disabled>
          {keycloak &&
            keycloak.realm === 'registrar' &&
            DARWIN_ROLES.map((r) => userDarwinRegistrarRoles(keycloak)?.includes(r) && <Tag>{r}</Tag>)}
          {keycloak && keycloak.realm === 'registry' && darwin_registry_role_list()}
        </Menu.Item>
      </Menu.ItemGroup>
      {keycloak && keycloak.realm === 'registry' && (
        <Menu.ItemGroup title={t('operatorUserRoles')}>
          <Menu.Item key={'hide-role'} disabled>
            {REGISTRY_USER_ROLES.map(
              (r) =>
                userRealmRegistryOperatorRoles(keycloak)?.includes(r) && (
                  <div>
                    <Tag>{r}</Tag>
                  </div>
                ),
            )}
          </Menu.Item>
        </Menu.ItemGroup>
      )}
      <Menu.Item key={'logout'}>{t('logout')}</Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu}>
      <Button type={'primary'} ghost style={{ color: `${clr}`, borderColor: `${clr}` }}>
        <Space>
          <RoleIcon />
          <Divider type={'vertical'} style={{ background: 'white' }} />
          <span>{username}</span>
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  )
}

function RoleIcon() {
  const { keycloak } = useAuth()
  let role = getUserDarwinRole(keycloak)
  //TODO aggiungere hint alle icone
  switch (role) {
    case 'admin':
      return <FontAwesomeIcon icon={faA} />
    case 'darwin-admin':
      return <FontAwesomeIcon icon={faA} />
    case 'domain':
      return <FontAwesomeIcon icon={faGlobe} />
    case 'darwin':
      return <FontAwesomeIcon icon={faD} />
    default:
      return <FontAwesomeIcon icon={faUser} style={{ color: 'lightgray' }} />
  }
}
